









































import { Component, Vue } from "vue-property-decorator";
import {
  dispatchGetAgreedLicenceVersion,
  dispatchGetLicence,dispatchSetLicenceAccepted,
  dispatchSetAgreedLicenceVersion, dispatchUpdateAgreedLicenceVersion
} from "@/store/main/actions";

@Component
export default class Dashboard extends Vue {

  public loading = true;
  public licences : any | null = null;
  public currentVersion = "";
  public agreedVersion = "";
  public agreedId = -1;
  public showAgreeButton = true;
  public async mounted() {
    this.loading = true;

    this.licences = await dispatchGetLicence(this.$store);
    this.currentVersion = this.licences.data.version;
    const agreed = await dispatchGetAgreedLicenceVersion(this.$store);
    this.agreedId = agreed.id;
    this.agreedVersion = agreed.data.version;

    console.log("c:"+this.currentVersion +" ag:"+this.agreedVersion +" id:"+this.agreedId);

    if (this.currentVersion == this.agreedVersion)
      this.showAgreeButton = false

    this.loading = false;
  }

  public async agreeLicence(){
    if (this.agreedId == -1){
      console.log("new licence");
      await dispatchSetAgreedLicenceVersion(this.$store,this.currentVersion);

    }else {
      console.log("update licence");
      await dispatchUpdateAgreedLicenceVersion(this.$store,{id: this.agreedId, version: this.currentVersion});
    }

    await dispatchSetLicenceAccepted(this.$store,true);
    await this.$router.push({name:'main-dashboard'});
  }
}
